
import request from '@/utils/request'

/**
 * @apiName 订单详情
 */
export function getOrderDetailApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/order/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 查询用户真实手机号
 */
export function queryPurchasePhoneApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/phone/query',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 查询街道信息（新增）
 */
export function queryPurchaseAddressApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/address/query',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 重新支付
 * @param {string} orderId 订单号
 */
export function purchaseMallPayApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/mall/pay',
    method: 'POST',
    data,
  })
}
